import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CoreRoutesModule } from './core.routes';
import { SearchDataService } from '../dashboard/searchData/search-data.service';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatOptionModule } from '@angular/material/core';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { SharedModule } from '@app/shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import {
  LayoutComponent,
  SidebarComponent,
  ForbiddenComponent,
  LoginComponent
} from './components';
import { ClickOutsideDirective } from '../shared/directives/click-out-side.directive';
import { HeaderComponent } from '@delhivery/auth';

@NgModule({
  declarations: [
    LayoutComponent,
    SidebarComponent,
    ForbiddenComponent,
    LoginComponent,
    ClickOutsideDirective
  ],
  imports: [
    CommonModule,
    FormsModule,
    CoreRoutesModule,
    MatSelectModule,
    MatInputModule,
    MatFormFieldModule,
    MatOptionModule,
    MatMenuModule,
    MatButtonModule,
    SharedModule,
    MatSnackBarModule,
    TranslateModule,
    HeaderComponent
  ],
  providers: [SearchDataService]
})
export class CoreModule {}
